<template>
    <el-dialog 
        :width="dialogWidth" 
        title="Delete template" 
        :visible.sync="dialogFormVisible" 
        :modalAppendToBody="false">

        <div>
            
            <h4>Are you sure you want to delete?</h4>
            <h5>This action cannot be undone.</h5>

            <el-button class="tst-confirm-delete-button" type="danger" text  @click="deleteTemplate()" >Delete Template</el-button>
            <el-button class="tst-cancel-delete-button" text @click="closeForm()">Cancel</el-button>
        </div>
    </el-dialog>
</template>

<script>
import EventService from "@/services/EventService.js";

export default {
  props: {
    template: Object
  },
  data() {
    return {
    dialogFormVisible: true,
    dialog: false,
    dialogWidth: "50%",
    loadingFormSubmit: false

    }
  },
  mounted(){
      var x = window.matchMedia("(max-width: 979px)");
              if (x.matches) 
              {
                this.dialogWidth = "100%"
              }
  },
    methods: {
    deleteTemplate() {
     
        EventService.deleteTemplate(this.template.texteditertemplateid).then(() => {
            
            this.$emit("template-deleted", this.template);
            
            this.closeForm();

            this.$store.dispatch("addNotification", {
            type: "success",
            Message: "Template deleted"
            })
        })
        .catch(error => {
            console.log(error)
            this.closeForm();
        });
},
    closeForm() {
      this.$emit("close-delete-template");
    }
  }
}
</script>

<style>

</style>